var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BarChart',{attrs:{"chart-data":_vm.datacollection,"bar-options":{},"css-classes":"application-chart-container"}})}
var staticRenderFns = []

export { render, staticRenderFns }